import axios from 'axios';

const baseURL = process.env.VUE_APP_API_URL;

class EnumService {
    static specializations() {
        const url = `${baseURL}/charity/specialization`;

        return axios.get(url);
    }

    static types() {
        const url = `${baseURL}/charity/type`;

        return axios.get(url);
    }

    static hospitals() {
        const url = `${baseURL}/hospital`;

        return axios.get(url);
    }


    static regions() {
        const url = `${baseURL}/region`;

        return axios.get(url);
    }


    static cities(region_id: any) {
        const url = `${baseURL}/region/${region_id}/city`;

        return axios.get(url);
    }

    static nationalities() {
        const url = `${baseURL}/charity/yaqeen-nationalities`;

        return axios.get(url);
    }

    static charities({ specialization_id, region_id, city_id }: any) {
        let url = `${baseURL}/charity/active-charities?`;
        if (specialization_id) {
            url += `speciality=${specialization_id}&`;
        }
        if (region_id) {
            url += `area=${region_id}&`;
        }
        if (city_id) {
            url += `city=${city_id}&`;
        }
        url = url.slice(-1) === '&' || url.slice(-1) === '?' ? url.slice(0, -1) : url;
        return axios.get(url);
    }
}

export default EnumService;

export enum USER_TYPE {
    Technical_Audit = "Technical_Audit",
    Medical_Audit = "Medical_Audit",
    Marketing_Audit = "Marketing_Audit",
    Admin = "Admin",
    Charity = "Charity",
    Charity_Representative = "Charity_Representative",
    First_Audit = "First_Audit",

    Second_Audit = "Second_Audit",

    Financial_Reviewer = "Financial_Reviewer",

    Transfer_Manager = "Transfer_Manager",

}

export enum CASE_STATUS {
    Charity_All = "Charity_All",
    Admin_All = "Admin_All",
    Admin_Cancellation = "Admin_Cancellation",
    Draft = "Draft",
    Final_Audit = "Final_Audit",
    Return_to_Final_Audit = "Return_to_Final_Audit",
    Ready_to_be_Published = "Ready_to_be_Published",
    Published = "Published",
    Rejected = "Rejected",
    Temp_Pause = "Temp_Pause",
    Technical_Audit_All = "Technical_Audit_All",
    Technical_Audit = "Technical_Audit",
    Technical_Feedback_Charity = "Technical_Feedback_Charity",
    Admin_Feedback_TA = "Admin_Feedback_TA",
    Marketing_Feedback_TA = "Marketing_Feedback_TA",
    Medical_Feedback_TA = "Medical_Feedback_TA",
    Medical_Audit_All = "Medical_Audit_All",
    Medical_Audit = "Medical_Audit",
    Admin_Feedback_MEA = "Admin_Feedback_MEA",
    Medical_Feedback_Charity = "Medical_Feedback_Charity",
    Marketing_Audit_All = "Marketing_Audit_All",
    Marketing_Audit = "Marketing_Audit",
    Admin_Feedback_MA = "Admin_Feedback_MA",
    Admin_Feedback_Charity = "Admin_Feedback_Charity",
    Ops_Feedback_TA = "Ops_Feedback_TA",
    Ops_Feedback_MEA = "Ops_Feedback_MEA",
    Ops_Feedback_MA = "Ops_Feedback_MA",
    Return_to_Ops_from_TA = "Return_to_Ops_from_TA",
    Return_to_Ops_from_MEA = "Return_to_Ops_from_MEA",
    Return_to_Ops_from_MA = "Return_to_Ops_from_MA",
    Donation_Completed = "Donation_Completed",
    Closed = "Closed",
    Waiting_Audit_1 = "Waiting_Audit_1",
    Waiting_Audit_2 = "Waiting_Audit_2",
    Waiting_review = "Waiting_review",
    Waiting_Transfer = "Waiting_Transfer",
    Feedback_Charity = "Feedback_Charity",
    Multiple_Phases = "Multiple_Phases",
    Cancellation_Confirmation = "Cancellation_Confirmation",
    Cancellation_Confirmation_F1 = "Cancellation_Confirmation_F1",
    Waiting_Transfer_Confirmation = "Waiting_Transfer_Confirmation",
    Rejected_Invoice = "Rejected_Invoice",
    Manager_Cancellation = "Manager_Cancellation",
    Financial_Manager_Feedback = "Financial_Manager_Feedback",
    Financial_Manager_1_Feedback = "Financial_Manager_1_Feedback",
    Financial_Reviewer_Feedback = "Financial_Reviewer_Feedback",
    Waiting_Completion = "Waiting_Completion",
    Charity_Payment_Completed = "Charity_Payment_Completed",
    Transfer_Returned = "Transfer_Returned",
    Cancelled = "Cancelled",
    Payment_Request_All = "Payment_Request_All",
    TA_Cancellation = "CC_TA",
    MEA_Cancellation = "CC_MEA",
    Cancelled_Reqs = "Cancelled_Reqs", //combines Rejected, System Cancellation, Admin_Cancellation, charity cancellation
    Operations_Manager = "Operations_Manager",
    Ops_Feedback_Charity = "Ops_Feedback_Charity",
    Operations_F1_Manager = "Operations_F1_Manager",
    Operations_F2_Manager = "Operations_F2_Manager",
    FM_2_Ops_Feedback = "FM_2_Ops_Feedback",
    FM_1_Ops_Feedback = "FM_1_Ops_Feedback",
}

/**
 * Case statuses in which a case has not been published yet, so the backend
 * always resolves "published_by" to null for them. Mirror of the backend
 * `_PRE_PUBLISHED_STATUSES` in `apps/charity/views.py` — keep the two in sync.
 *
 * Used to hide the "Published By" column/filter on tabs where it would only
 * ever render empty (e.g. the technical-auditor workflow tabs).
 */
export const PRE_PUBLISHED_CASE_STATUSES: CASE_STATUS[] = [
    CASE_STATUS.Draft,
    CASE_STATUS.Technical_Audit,
    CASE_STATUS.Technical_Feedback_Charity,
    CASE_STATUS.Medical_Audit,
    CASE_STATUS.Medical_Feedback_Charity,
    CASE_STATUS.Marketing_Audit,
    CASE_STATUS.Marketing_Feedback_TA,
    CASE_STATUS.Medical_Feedback_TA,
    CASE_STATUS.Final_Audit,
    CASE_STATUS.Return_to_Final_Audit,
    CASE_STATUS.Ready_to_be_Published,
    CASE_STATUS.Admin_Feedback_TA,
    CASE_STATUS.Admin_Feedback_MEA,
    CASE_STATUS.Admin_Feedback_MA,
    CASE_STATUS.Ops_Feedback_TA,
    CASE_STATUS.Ops_Feedback_MEA,
    CASE_STATUS.Ops_Feedback_MA,
    CASE_STATUS.Admin_Feedback_Charity,
    CASE_STATUS.Ops_Feedback_Charity,
    CASE_STATUS.Rejected,
];

export enum PAYMENT_REQUEST_ENUM {
    Closed = "مغلقة",
    Waiting_Audit_1 = "بانتظار التدقيق المالي 1",
    Waiting_Audit_2 = "بانتظار التدقيق المالي 2",
    Waiting_review = "بانتظار المراجعة المالية",
    Waiting_Transfer = "بانتظار التحويل",
    Feedback_Charity = "معاد من المراجع المالي الى الجمعية",
    Cancellation_Confirmation = "بانتظار اعتماد الالغاء",
    Waiting_Transfer_Confirmation = "بانتظار اشعار التحويل",
    Rejected_Invoice = "ملغي من مدير النظام",
    Manager_Cancellation = "فاتورة مرفوضة",
    Payment_Request_Manager_Cancellation = "ملغي من مدير التحويل",
    Financial_Manager_Feedback = "إعادة الحالة الى مدقق مالي ٢",
    Financial_Reviewer_Feedback = "إعادة الحالة الى المدقق المالي الثاني",
    Waiting_Completion = "بانتظار تاكيد السداد",
    Charity_Payment_Completed = "تم السداد للجمعية",
    // TODO(copy) — keep identical to payoutReturnCopy.statusLabel until SHEFA2-4466 copy sign-off (F2).
    Transfer_Returned = "(مسودة) حوالة مرتجعة",
}

export enum ARABIC_CASES_STATUS {
    DRAFT = "مسودة",
    TECHNICAL_AUDIT = "بانتظار التدقيق الفني",
    TECHNICAL_FEEDBACK_CHARITY = "معاد من الفني إلى الجمعية",
    MEDICAL_AUDIT = "بانتظار التدقيق الطبي",
    MEDICAL_FEEDBACK_CHARITY = "معاد من الطبي إلى الجمعية",
    MARKETING_AUDIT = "بانتظار الإعداد التسويقي",
    MARKETING_FEEDBACK_TA = "معاد من التسويقي إلى الفني",
    FINAL_AUDIT = "بانتظار التدقيق النهائي",
    READY_TO_BE_PUBLISHED = "الجاهزة للنشر",
    ADMIN_FEEDBACK_TA = "معاد من مدير النظام  إلى الفني",
    ADMIN_FEEDBACK_MEA = "معاد من مدير النظام  إلى الطبي",
    ADMIN_FEEDBACK_MA = "معاد من مدير النظام  إلى التسويقي",
    ADMIN_FEEDBACK_CHARITY = "معاد من مدير النظام  إلى الجمعية",
    OPS_FEEDBACK_CHARITY = 'معاد من مدير العمليات  إلى الجمعية',
    PUBLISHED = "منشور",
    REJECTED = "ملغي",
    SYSTEM_CANCELLATION = "ملغي من النظام",
    CHARITY_CANCELLATION = "ملغي من الجمعية",
    ADMIN_CANCELLATION = "ملغي من مدير النظام",
    TEMP_PAUSE = "موقوف",
    DONATION_COMPLETED = "بانتظار الفاتورة",
    MULTIPLE_PHASES = "مراحل متعددة",
    CLOSED = "مغلقة",
    WAITING_AUDIT_1 = "بانتظار التدقيق المالي 1",
    WAITING_AUDIT_2 = "بانتظار التدقيق المالي 2",
    WAITING_REVIEW = "بانتظار المراجعة المالية",
    WAITING_TRANSFER = "بانتظار التحويل",
    FEEDBACK_CHARITY = "معاد من المراجع المالي",
    CANCELLATION_CONFIRMATION = "بانتظار اعتماد الرفض",
    WAITING_TRANSFER_CONFIRMATION = "بانتظار اشعار التحويل",
    REJECTED_INVOICE = "ملغي من مدير النظام",
    MANAGER_CANCELLATION = "فاتورة مرفوضة",
    FINANCIAL_MANAGER_FEEDBACK = "إعادة الحالة الى مدقق مالي ٢",
    FINANCIAL_REVIEWER_FEEDBACK = "معاد من المراجع المالي الى المالي ٢",
    CHARITY_PAYMENT_COMPLETED = "تم السداد للجمعية",
    CASE_CREATION = 'انشاء الحالة',
    APPLICATION_STUDY = 'دراسة الطلب',
    FINANCIAL_REVIEW = 'مراجعة مالية',
    COMPLETED = 'مكتملة',
    OPS_FEEDBACK_TA = "معاد من مدير العمليات إلى الفني",
    OPS_FEEDBACK_MEA = "معاد من مدير العمليات  إلى الطبي",
    OPS_FEEDBACK_MA = "معاد من مدير العمليات  إلى التسويقي",
    RETURN_TO_FINAL_AUDIT = "معاد للتدقيق النهائي",
    RETURN_TO_OPS_FROM_TA = "معاد لمدير العمليات من الفني",
    RETURN_TO_OPS_FROM_MEA = "معاد لمدير العمليات من الطبي",
    RETURN_TO_OPS_FROM_MA = "معاد لمدير العمليات من التسويقي",
    FM_1_OPS_FEEDBACK = "معاد من مدير العمليات إلى المالي ١",
    FM_2_OPS_FEEDBACK = "معاد من مدير العمليات إلى المالي ٢",
    Transfer_Manager_to_F2 = "معاد من مدير التحويل الى المالي ٢",
    OPS_MANAGER_CANCELLATION ="ملغي من مدير العمليات",
    OPS_MANAGER_F1_CANCELLATION ="ملغي من المدقق المالي ١",
    OPS_MANAGER_F2_CANCELLATION = "ملغي من المدقق المالي ٢",
    TA_CANCELLATION = "ملغي من المدقق الفني",
    MEA_CANCELLATION = "ملغي من المدقق الطبي",
    PAYMENT_REQUEST_MANAGER_CANCELLATION = "ملغي من مدير التحويل",
    REACTIVATE_TA = "تفعيل وارسال للمدقق الفني",
    REACTIVATE_MEA = "تفعيل وارسال للمدقق الطبي",
}


export enum USER_TYPE_AR {
    First_Audit = "مدقق مالي أول",
    Second_Audit = "مدقق مالي ثاني",
    Financial_Reviewer = "المراجع المالي",
    Transfer_Manager = "مدير التحويل",
    System_Administrator = "مدير نظام",
    Operations_Manager = "مدير العمليات",
}

export enum PROCEDURES_MAPPING_AR {
    Waiting_Transfer_Confirmation = "تحويل المبلغ للجمعية",
    Waiting_Transfer = "اعتماد أمر الصرف",
    Feedback_Charity = "اعادة للجمعية من المدقق المالي",
    Waiting_review = "اصدار أمر الصرف",
    Cancellation_Confirmation = "إلغاء الطلب",
    Cancellation_Confirmation_F1 = "إلغاء الطلب",
    FM_1_Ops_Feedback = "معاد من مدير العمليات إلى المالي ١",
    FM_2_Ops_Feedback = "معاد من مدير العمليات إلى المالي ٢",
    Operations_Manager = "إلغاء الطلب",
    Operations_F1_Manager = "إلغاء الطلب",
    Operations_F2_Manager = "إلغاء الطلب",
    Waiting_Audit_2 = " قبول و ارسال للمدقق المالي الثاني",
    Closed = "مغلقة",
    Waiting_Audit_1 = "بانتظار التدقيق المالي 1",
    Rejected_Invoice = "ملغي من مدير النظام",
    Manager_Cancellation = "فاتورة مرفوضة",
    Financial_Manager_Feedback = "إعادة الحالة الى مدقق مالي ٢",
    Financial_Manager_1_Feedback = "إعادة الحالة الى مدقق مالي ١",
    Financial_Reviewer_Feedback = "إعادة الحالة الى المدقق المالي الثاني",
    Waiting_Completion = "بانتظار تاكيد السداد",
    Charity_Payment_Completed = "تم السداد للجمعية",
}

export enum PAYMENT_REQUEST_ACTION {
    edit_payment_request = "edit_payment_request",
    view_payment_request = "view_payment_request",
    record_payout_return = "record_payout_return",
    retransfer_payout = "retransfer_payout"
}

/** SHEFA2-4466 — `invoicing/helpers.py` `release_halves_map` role key. */
export enum PAYOUT_HALF {
    beneficiary = "beneficiary",
    shefa = "shefa",
}

/** SHEFA2-4466 — BE §1 table; a half's lifecycle state (not the raw payout `status`). */
export enum PAYOUT_HALF_STATE {
    returned = "returned",
    settled = "settled",
    in_flight = "in_flight",
    rejected = "rejected",
    failed_reversed = "failed_reversed",
    auto_retry = "auto_retry",
    failed = "failed",
    failed_internal = "failed_internal",
}

/** SHEFA2-4466 — mirrors BE `Payment.PayoutFailureReason` (`apps/payment/models.py:77-84`). */
export enum PAYOUT_FAILURE_REASON {
    reversed_by_bank = "reversed_by_bank",
    duplicate_payout = "duplicate_payout",
    incorrect_iban = "incorrect_iban",
    charity_requested_reversal = "charity_requested_reversal",
    other = "other",
}

export enum DONATION_TYPE {
    CASE = "CASE",
    WAQF = "WAQF",
    ALL_CASES_DONATION = "ALL_CASES_DONATION",
    CAMPAIGN = "CAMPAIGN",
    ZAKAT = "ZAKAT",
    ALL_PATIENTS = "ALL_PATIENTS",
    GIFT_CARD = "GIFT_CARD",
    MAJOR_DONOR = "MAJOR_DONOR",
    HEF = "HEF",
}

export enum USER_ROLES_AR {
    SYSTEM_ADMINISTRATOR = 'مدير نظام',
    FINANCIAL_REFERENCES = 'المراجع المالي',
    CHARITY_REPRESENTATIVE = 'وكيل جمعية',
    CHARITY_MANAGER = "مدير جمعية",
    ASSOCIATION_MANAGEMENT = "إدارة الجمعيات",
    MOH_REPRESENTATIVE = "ممثل وزارة الصحة",
    OPERATIONS_MANAGER = "مدير العمليات",
    MARKETING_AUDITOR = "مدقق تسويقي",
    TRANSFER_MANAGER = "مدير مالي",
    ENDOWMENT_ADMINISTRATOR = "مدير الأوقاف",
    FINANCIAL_MANAGER_1 = "مدقق مالي أول",
    FINANCIAL_MANAGER_2 = "مدقق مالي ثاني",
}

export enum DOCUMENT_NAMES {
    AUTH_LETTER = "خطاب رسمي من صاحب الصلاحية بالانضمام للمنصة",
    BASIC_REGULATIONS = "اللائحة الأساسية",
    FINANCIAL_STATEMENT = "قوائم مالية لآخر سنة",
    GOVERNANCE_REPORT = "تقرير الحوكمة",
    PATIENT_WAITLIST = "قوائم انتظار للمرضى ممن ليس لديهم أهلية علاج في وزارة الصحة",
    AGREEMENT_ATTACHMENT = "اتفاقيات مزودي الخدمة المستشفيات",
}

export const MOBILE_ROUTES = [
    'privacy-policy-mobile',
    'mobile-payment-confirmation',
    'mobile-checkout',
    'mobile-payment-success',
    'mobile-payment-pending',
    'mobile-payment-failure',
    'mobile-saved-cards'
]

export const REGIONS = [
    {
        "id": 1,
        "name": "الرياض"
    },
    {
        "id": 2,
        "name": "المنطقة الشرقية"
    },
    {
        "id": 3,
        "name": "مكة المكرمة"
    },
    {
        "id": 8,
        "name": "المدينة المنورة"
    },
    {
        "id": 9,
        "name": "القصيم"
    },
    {
        "id": 10,
        "name": "عسير"
    },
    {
        "id": 11,
        "name": "تبوك"
    },
    {
        "id": 12,
        "name": "حائل"
    },
    {
        "id": 13,
        "name": "الحدود الشمالية"
    },
    {
        "id": 14,
        "name": "جازان"
    },
    {
        "id": 15,
        "name": "نجران"
    },
    {
        "id": 16,
        "name": "الباحة"
    },
    {
        "id": 17,
        "name": "الجوف"
    },
    {
        "id": 18,
        "name": "غير محدد"
    }
]

export const SPECIALTIES = [
    {
        "id": 16,
        "name": "الجراحة العامة"
    },
    {
        "id": 15,
        "name": "الأجهزة الطبية"
    },
    {
        "id": 14,
        "name": "النفسية"
    },
    {
        "id": 13,
        "name": "النساء و الولادة"
    },
    {
        "id": 12,
        "name": "الكلى و المسالك البولية"
    },
    {
        "id": 11,
        "name": "القلب و الشرايين"
    },
    {
        "id": 10,
        "name": "الغدد الصماء و المناعة"
    },
    {
        "id": 9,
        "name": "العيون"
    },
    {
        "id": 8,
        "name": "العظام و المفاصل"
    },
    {
        "id": 7,
        "name": "الصدرية"
    },
    {
        "id": 6,
        "name": "الدم و الأورام"
    },
    {
        "id": 5,
        "name": "الجهاز الهضمي"
    },
    {
        "id": 4,
        "name": "الجلدية"
    },
    {
        "id": 3,
        "name": "الأنف و الأذن و الحنجرة"
    },
    {
        "id": 2,
        "name": "الأعصاب"
    },
    {
        "id": 1,
        "name": "الأكثر حاجة"
    }
]
// Speciality used to pull the "most needed" cases (الأكثر حاجة) from the case
// cards endpoint.
export const MOST_NEEDED_SPECIALTY_ID = 1;
export const PAYMENT_REQUEST_ACTIONS = [
    "Closed",
    "Waiting_Audit_1",
    "Waiting_Audit_2",
    "Waiting_review",
    "Waiting_Transfer",
    "Feedback_Charity",
    "Cancellation_Confirmation_F1",
    "Cancellation_Confirmation",
    "Operations_F1_Manager",
    "Operations_F2_Manager",
    "Waiting_Transfer_Confirmation",
    "Rejected_Invoice",
    "Manager_Cancellation",
    "Financial_Manager_1_Feedback",
    "Transfer_Manager_to_F2",
    "Financial_Manager_Feedback",
    "Financial_Reviewer_Feedback",
    "FM_1_Ops_Feedback",
    "FM_2_Ops_Feedback",
    "Charity_Payment_Completed",
    "إعادة الحالة الى مدقق مالي ٢",
]